import { Theme } from '@lib/theming/Theme'
import { Box, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { Maybe } from '@ts/operations'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles<Theme>(({ breakpoints, palette }) => ({
  currencySymbol: {
    [breakpoints.between('md', 'lg')]: {
      fontSize: '0.75rem',
    },
    color: palette.common.black,
    fontSize: '1.025rem',
  },
  descriptionWrapper: {
    [breakpoints.only('md')]: {
      width: '100%',
    },
    color: palette.grey[500],
  },
  priceAmount: {
    [breakpoints.between('md', 'lg')]: {
      fontSize: '2.625rem',
      wordBreak: 'break-all',
    },
    color: palette.common.black,
    fontSize: '3.025rem',
    fontWeight: 600,
    lineHeight: 1,
  },
  promoted: { color: palette.common.white },
  root: {
    color: palette.common.black,
  },
}))

type ReleasePriceProps = {
  amountExTax: string
  amountIncTax: string
  description?: Maybe<string>
  displayPriceIncludingTax: boolean
  displaySubPrice?: boolean
  symbol: string
  variant?: string
}

const ReleasePrice = ({
  amountExTax,
  amountIncTax,
  description,
  variant = 'standard',
  displaySubPrice = true,
  displayPriceIncludingTax,
  symbol,
}: ReleasePriceProps) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, classes[variant])}>
      <Grid container alignItems="baseline">
        <Box
          alignSelf="flex-start"
          className={clsx(classes.currencySymbol, classes[variant])}
          pt={0.4}
        >
          {symbol}
        </Box>
        <Box className={clsx(classes.priceAmount, classes[variant])} pb={0.5} pl={0.3}>
          {displayPriceIncludingTax ? amountIncTax : amountExTax}
        </Box>
      </Grid>

      {amountExTax !== amountIncTax ? (
        <Grid container alignItems="baseline">
          {displaySubPrice ? (
            <Box className={clsx(classes.descriptionWrapper, classes[variant])}>
              {symbol}
              {displayPriceIncludingTax ? amountExTax : amountIncTax} {description}
            </Box>
          ) : (
            <Box className={clsx(classes.descriptionWrapper, classes[variant])}>{description}</Box>
          )}
        </Grid>
      ) : null}
    </div>
  )
}

export default ReleasePrice
